'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var Form = {};

var FormContext = React.createContext({
    formName: undefined,
    registerField: undefined
});

var FormFieldRegistry = {};

var FormFieldSubscriptions = {};

var cleanForm = function (formName, cleanOnUnmount) { return function () { return function () {
    if (!cleanOnUnmount) {
        return;
    }
    delete Form[formName];
    delete FormFieldSubscriptions[formName];
    delete FormFieldRegistry[formName];
}; }; };

(function (ValidationTrigger) {
    ValidationTrigger[ValidationTrigger["ON_CHANGE"] = 0] = "ON_CHANGE";
    ValidationTrigger[ValidationTrigger["BLUR"] = 1] = "BLUR";
})(exports.ValidationTrigger || (exports.ValidationTrigger = {}));
(function (ValidationOrder) {
    ValidationOrder[ValidationOrder["BEFORE_MASK"] = 0] = "BEFORE_MASK";
    ValidationOrder[ValidationOrder["AFTER_MASK"] = 1] = "AFTER_MASK";
})(exports.ValidationOrder || (exports.ValidationOrder = {}));

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var objectPath = createCommonjsModule(function (module) {
(function (root, factory){

  /*istanbul ignore next:cant test*/
  {
    module.exports = factory();
  }
})(commonjsGlobal, function(){

  var toStr = Object.prototype.toString;
  function hasOwnProperty(obj, prop) {
    if(obj == null) {
      return false
    }
    //to handle objects with null prototypes (too edge case?)
    return Object.prototype.hasOwnProperty.call(obj, prop)
  }

  function isEmpty(value){
    if (!value) {
      return true;
    }
    if (isArray(value) && value.length === 0) {
        return true;
    } else if (typeof value !== 'string') {
        for (var i in value) {
            if (hasOwnProperty(value, i)) {
                return false;
            }
        }
        return true;
    }
    return false;
  }

  function toString(type){
    return toStr.call(type);
  }

  function isObject(obj){
    return typeof obj === 'object' && toString(obj) === "[object Object]";
  }

  var isArray = Array.isArray || function(obj){
    /*istanbul ignore next:cant test*/
    return toStr.call(obj) === '[object Array]';
  };

  function isBoolean(obj){
    return typeof obj === 'boolean' || toString(obj) === '[object Boolean]';
  }

  function getKey(key){
    var intKey = parseInt(key);
    if (intKey.toString() === key) {
      return intKey;
    }
    return key;
  }

  function factory(options) {
    options = options || {};

    var objectPath = function(obj) {
      return Object.keys(objectPath).reduce(function(proxy, prop) {
        if(prop === 'create') {
          return proxy;
        }

        /*istanbul ignore else*/
        if (typeof objectPath[prop] === 'function') {
          proxy[prop] = objectPath[prop].bind(objectPath, obj);
        }

        return proxy;
      }, {});
    };

    function hasShallowProperty(obj, prop) {
      return (options.includeInheritedProps || (typeof prop === 'number' && Array.isArray(obj)) || hasOwnProperty(obj, prop))
    }

    function getShallowProperty(obj, prop) {
      if (hasShallowProperty(obj, prop)) {
        return obj[prop];
      }
    }

    function set(obj, path, value, doNotReplace){
      if (typeof path === 'number') {
        path = [path];
      }
      if (!path || path.length === 0) {
        return obj;
      }
      if (typeof path === 'string') {
        return set(obj, path.split('.').map(getKey), value, doNotReplace);
      }
      var currentPath = path[0];
      var currentValue = getShallowProperty(obj, currentPath);
      if (path.length === 1) {
        if (currentValue === void 0 || !doNotReplace) {
          obj[currentPath] = value;
        }
        return currentValue;
      }

      if (currentValue === void 0) {
        //check if we assume an array
        if(typeof path[1] === 'number') {
          obj[currentPath] = [];
        } else {
          obj[currentPath] = {};
        }
      }

      return set(obj[currentPath], path.slice(1), value, doNotReplace);
    }

    objectPath.has = function (obj, path) {
      if (typeof path === 'number') {
        path = [path];
      } else if (typeof path === 'string') {
        path = path.split('.');
      }

      if (!path || path.length === 0) {
        return !!obj;
      }

      for (var i = 0; i < path.length; i++) {
        var j = getKey(path[i]);

        if((typeof j === 'number' && isArray(obj) && j < obj.length) ||
          (options.includeInheritedProps ? (j in Object(obj)) : hasOwnProperty(obj, j))) {
          obj = obj[j];
        } else {
          return false;
        }
      }

      return true;
    };

    objectPath.ensureExists = function (obj, path, value){
      return set(obj, path, value, true);
    };

    objectPath.set = function (obj, path, value, doNotReplace){
      return set(obj, path, value, doNotReplace);
    };

    objectPath.insert = function (obj, path, value, at){
      var arr = objectPath.get(obj, path);
      at = ~~at;
      if (!isArray(arr)) {
        arr = [];
        objectPath.set(obj, path, arr);
      }
      arr.splice(at, 0, value);
    };

    objectPath.empty = function(obj, path) {
      if (isEmpty(path)) {
        return void 0;
      }
      if (obj == null) {
        return void 0;
      }

      var value, i;
      if (!(value = objectPath.get(obj, path))) {
        return void 0;
      }

      if (typeof value === 'string') {
        return objectPath.set(obj, path, '');
      } else if (isBoolean(value)) {
        return objectPath.set(obj, path, false);
      } else if (typeof value === 'number') {
        return objectPath.set(obj, path, 0);
      } else if (isArray(value)) {
        value.length = 0;
      } else if (isObject(value)) {
        for (i in value) {
          if (hasShallowProperty(value, i)) {
            delete value[i];
          }
        }
      } else {
        return objectPath.set(obj, path, null);
      }
    };

    objectPath.push = function (obj, path /*, values */){
      var arr = objectPath.get(obj, path);
      if (!isArray(arr)) {
        arr = [];
        objectPath.set(obj, path, arr);
      }

      arr.push.apply(arr, Array.prototype.slice.call(arguments, 2));
    };

    objectPath.coalesce = function (obj, paths, defaultValue) {
      var value;

      for (var i = 0, len = paths.length; i < len; i++) {
        if ((value = objectPath.get(obj, paths[i])) !== void 0) {
          return value;
        }
      }

      return defaultValue;
    };

    objectPath.get = function (obj, path, defaultValue){
      if (typeof path === 'number') {
        path = [path];
      }
      if (!path || path.length === 0) {
        return obj;
      }
      if (obj == null) {
        return defaultValue;
      }
      if (typeof path === 'string') {
        return objectPath.get(obj, path.split('.'), defaultValue);
      }

      var currentPath = getKey(path[0]);
      var nextObj = getShallowProperty(obj, currentPath);
      if (nextObj === void 0) {
        return defaultValue;
      }

      if (path.length === 1) {
        return nextObj;
      }

      return objectPath.get(obj[currentPath], path.slice(1), defaultValue);
    };

    objectPath.del = function del(obj, path) {
      if (typeof path === 'number') {
        path = [path];
      }

      if (obj == null) {
        return obj;
      }

      if (isEmpty(path)) {
        return obj;
      }
      if(typeof path === 'string') {
        return objectPath.del(obj, path.split('.'));
      }

      var currentPath = getKey(path[0]);
      if (!hasShallowProperty(obj, currentPath)) {
        return obj;
      }

      if(path.length === 1) {
        if (isArray(obj)) {
          obj.splice(currentPath, 1);
        } else {
          delete obj[currentPath];
        }
      } else {
        return objectPath.del(obj[currentPath], path.slice(1));
      }

      return obj;
    };

    return objectPath;
  }

  var mod = factory();
  mod.create = factory;
  mod.withInheritedProps = factory({includeInheritedProps: true});
  return mod;
});
});

var DEFAULT_FORM_NAME = 'default';

var Defaults = {
    formName: DEFAULT_FORM_NAME,
    validationOptions: {
        trigger: exports.ValidationTrigger.BLUR,
        order: exports.ValidationOrder.AFTER_MASK,
    },
    cleanOnUnmount: true,
};
var setDefaults = function (defaults) {
    Defaults = __assign(__assign({}, Defaults), defaults);
};
var getDefaults = function () { return Defaults; };
var getDefaultFormName = function () { return Defaults.formName; };

var formFieldRegistrationKey = '__fieldRegistration';
var setFormFieldRegistration = function (formName, fieldName, value) {
    objectPath.set(FormFieldRegistry, formName + "." + fieldName + "." + formFieldRegistrationKey, value);
};
var getFormFieldRegistration = function (formName, fieldName) {
    return objectPath.get(FormFieldRegistry, formName + "." + fieldName + "." + formFieldRegistrationKey);
};
var getFormFieldRegistrationSubfields = function (formName, fieldName) {
    return objectPath.get(FormFieldRegistry, formName + "." + fieldName);
};

var buildOnChangeError = function (config) { return function (error) {
    var _a = __assign({ formName: getDefaults().formName }, config), formName = _a.formName, fieldName = _a.fieldName;
    var errorListener = getFormFieldRegistration(formName, fieldName).errorListener;
    objectPath.set(Form[formName].errors, fieldName, error);
    errorListener(error);
    Object.values((FormFieldSubscriptions[formName][fieldName] || {}).errorListenerSubscribers || {})
        .forEach(function (listener) { return listener(error); });
}; };

var buildOnChangeValue = function (config) { return function (value) {
    var _a = __assign({ formName: DEFAULT_FORM_NAME }, config), formName = _a.formName, fieldName = _a.fieldName;
    var boundingForm = Form[formName];
    var fieldRegistration = getFormFieldRegistration(formName, fieldName);
    var changeListener = fieldRegistration.changeListener, fieldRegistrationFieldName = fieldRegistration.fieldName;
    var finalValue = value;
    validateValue(finalValue, exports.ValidationOrder.BEFORE_MASK, formName, fieldRegistration);
    finalValue = applyMask(finalValue, fieldRegistration);
    validateValue(finalValue, exports.ValidationOrder.AFTER_MASK, formName, fieldRegistration);
    objectPath.set(boundingForm.values, fieldName, finalValue);
    boundingForm.dirty = true;
    changeListener(finalValue);
    if (shouldBubbleEvent(boundingForm, fieldRegistration)) {
        bubbleUp(fieldName, formName);
        bubbleDown(fieldName, formName);
    }
    Object.values((FormFieldSubscriptions[formName][fieldName] || {}).changeListenerSubscribers || {})
        .forEach(function (listener) { return listener(finalValue); });
}; };
var bubbleUp = function (fieldName, formName) {
    var boundingForm = Form[formName];
    var value = getFormFieldRegistrationSubfields(formName, fieldName);
    if (typeof value === 'object') {
        Object.keys(value).forEach(function (candidateSubfield) {
            var _a;
            if (candidateSubfield === '__fieldRegistration') {
                return;
            }
            var possibleFieldRegistrationKey = fieldName + "." + candidateSubfield;
            var fieldRegistration = getFormFieldRegistration(formName, possibleFieldRegistrationKey);
            (_a = fieldRegistration === null || fieldRegistration === void 0 ? void 0 : fieldRegistration.changeListener) === null || _a === void 0 ? void 0 : _a.call(fieldRegistration, objectPath.get(boundingForm.values, possibleFieldRegistrationKey));
            bubbleUp(possibleFieldRegistrationKey, formName);
        });
    }
};
var bubbleDown = function (fieldName, formName) {
    var _a;
    var boundingForm = Form[formName];
    var allParentFields = fieldName.split('.');
    if (allParentFields.length > 1) {
        var possibleParentFieldRegistrationKey = allParentFields.slice(0, -1).join('.');
        var fieldRegistration = getFormFieldRegistration(formName, possibleParentFieldRegistrationKey);
        (_a = fieldRegistration === null || fieldRegistration === void 0 ? void 0 : fieldRegistration.changeListener) === null || _a === void 0 ? void 0 : _a.call(fieldRegistration, objectPath.get(boundingForm.values, possibleParentFieldRegistrationKey));
        bubbleDown(possibleParentFieldRegistrationKey, formName);
    }
};
var shouldBubbleEvent = function (form, fieldRegistration) {
    var _a;
    return (_a = fieldRegistration.enableEventBubbling) !== null && _a !== void 0 ? _a : form.enableEventBubbling;
};
var applyMask = function (value, fieldRegistration) {
    var mask = fieldRegistration.mask, unmask = fieldRegistration.unmask, saveUnmaskedValue = fieldRegistration.saveUnmaskedValue, fieldName = fieldRegistration.fieldName;
    if (saveUnmaskedValue) {
        if (typeof unmask === 'function') {
            return unmask(value);
        }
        console.warn("Form field " + fieldName + " was set with saveUnmaskedValue = true but no valid unmask function was supplied. This probably leads to unexpected behaviour.");
        return value;
    }
    if (typeof mask === 'function') {
        return mask(value);
    }
    return value;
};
var validateValue = function (value, order, formName, fieldRegistration) {
    var validationOptions = fieldRegistration.validationOptions, validator = fieldRegistration.validator, fieldName = fieldRegistration.fieldName;
    if (validationOptions
        && validationOptions.order === order
        && validationOptions.trigger === exports.ValidationTrigger.ON_CHANGE
        && typeof validator === 'function') {
        var error = validator(value);
        buildOnChangeError({ formName: formName, fieldName: fieldName })(error);
    }
};

var onBlur = function (config) { return function () {
    var _a = __assign({ formName: getDefaults().formName }, config), formName = _a.formName, fieldName = _a.fieldName;
    var fieldRegistration = getFormFieldRegistration(formName, fieldName);
    if (fieldRegistration.validationOptions.trigger !== exports.ValidationTrigger.BLUR) {
        return;
    }
    var fieldValue = objectPath.get(Form[formName].values, fieldName);
    validateValue$1(fieldValue, formName, fieldRegistration);
}; };
var validateValue$1 = function (value, formName, fieldRegistration) {
    var validator = fieldRegistration.validator, fieldName = fieldRegistration.fieldName;
    if (typeof validator === 'function') {
        var error = validator(value);
        buildOnChangeError({ formName: formName, fieldName: fieldName })(error);
    }
};

var registerField = function (formName) { return function (input) {
    if (!Form[formName]) {
        throw new Error('FormNotFound').message = "No form was found for the given name '" + formName + "'. Did you forget to call 'useForm()'?";
    }
    var fieldName = input.fieldName, validationOptions = input.validationOptions;
    setFormFieldRegistration(formName, fieldName, __assign(__assign({}, input), { validationOptions: __assign(__assign({}, defaultValidateOptions), validationOptions) }));
    var onChange = buildOnChangeValue({ fieldName: fieldName, formName: formName });
    var onError = buildOnChangeError({ fieldName: fieldName, formName: formName });
    var onBlur$$1 = onBlur({ fieldName: fieldName, formName: formName });
    // TODO unregister
    return { onChange: onChange, onError: onError, onBlur: onBlur$$1 };
}; };
var defaultValidateOptions = {
    trigger: exports.ValidationTrigger.ON_CHANGE,
    order: exports.ValidationOrder.AFTER_MASK
};

var eventBubblingEnabled = false;
var setEventBubblingEnabled = function (enabled) {
    eventBubblingEnabled = enabled;
};

var useForm = function (_a) {
    var _b = _a === void 0 ? {} : _a, initialValues = _b.initialValues, givenFormName = _b.formName, validator = _b.validator, validationOptions = _b.validationOptions, givenCleanOnUnmount = _b.cleanOnUnmount, enableEventBubbling = _b.enableEventBubbling;
    var defaults = getDefaults();
    var formName = givenFormName || defaults.formName;
    var cleanOnUnmount = givenCleanOnUnmount !== undefined ? givenCleanOnUnmount : defaults.cleanOnUnmount;
    var FormComponent = React.useMemo(function () {
        initializeForm({ formName: formName, initialValues: initialValues, validationOptions: validationOptions, enableEventBubbling: enableEventBubbling });
        return function (props) {
            return React.createElement(FormContext.Provider, __assign({ value: { registerField: registerField(formName), formName: formName } }, props));
        };
    }, []);
    var submit = React.useCallback(buildSubmit(formName, validator), [formName, validator]);
    var reset = React.useCallback(buildReset(formName, validator), [formName, validator]);
    React.useEffect(cleanForm(formName, cleanOnUnmount), []);
    return { Form: FormComponent, submit: submit, reset: reset };
};
var initializeForm = function (_a) {
    var initialValues = _a.initialValues, formName = _a.formName, validationOptions = _a.validationOptions, enableEventBubbling = _a.enableEventBubbling;
    var defaults = getDefaults();
    Form[formName] = {
        fields: {},
        initialValues: __assign({}, (initialValues || {})),
        values: __assign({}, (initialValues || {})),
        errors: {},
        dirty: false,
        validationOptions: __assign(__assign({}, defaults.validationOptions), (validationOptions || {})),
        enableEventBubbling: enableEventBubbling !== null && enableEventBubbling !== void 0 ? enableEventBubbling : eventBubblingEnabled,
    };
    FormFieldRegistry[formName] = {};
    FormFieldSubscriptions[formName] = {};
};
var buildSubmit = function (formName, validator) {
    return function (onSuccess, onError) { return __awaiter(void 0, void 0, void 0, function () {
        var values, errors, validatorResult, hasErrors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    values = Form[formName].values;
                    errors = Form[formName].errors || {};
                    if (!(typeof validator === 'function')) return [3 /*break*/, 2];
                    return [4 /*yield*/, validator(values)];
                case 1:
                    validatorResult = _a.sent();
                    errors = __assign(__assign({}, errors), validatorResult);
                    _a.label = 2;
                case 2:
                    hasErrors = evaluateErrors(errors, formName);
                    if (hasErrors) {
                        return [2 /*return*/, onError(errors)];
                    }
                    onSuccess(values);
                    return [2 /*return*/];
            }
        });
    }); };
};
var buildReset = function (formName, validator) { return function () {
    var fieldNames = Object.keys(FormFieldRegistry[formName] || {});
    var initialValues = Form[formName].initialValues;
    Form[formName].values = __assign({}, initialValues);
    fieldNames.forEach(function (fieldName) {
        var changeListeners = Object.values((FormFieldSubscriptions[formName][fieldName] || {}).changeListenerSubscribers || {});
        changeListeners.forEach(function (listener) { return listener(initialValues[fieldName]); });
        FormFieldRegistry[formName][fieldName].changeListener(initialValues[fieldName]);
    });
    if (typeof validator === 'function') {
        var errors = validator(initialValues);
        evaluateErrors(errors, formName);
    }
}; };
var evaluateErrors = function (errors, formName) {
    var hasErrors = false;
    notifyErrors(errors, formName, function () {
        hasErrors = true;
    });
    return hasErrors;
};
var notifyErrors = function (errors, formName, setHasErrors) {
    Object.keys(errors).forEach(function (errKey) {
        var _a, _b;
        var error = errors[errKey];
        if (!!error) {
            setHasErrors();
        }
        (_a = getFormFieldRegistration(formName, errKey)) === null || _a === void 0 ? void 0 : _a.errorListener(error);
        var errorListeners = Object.values(((_b = objectPath.get(FormFieldSubscriptions, formName + "." + errKey)) === null || _b === void 0 ? void 0 : _b.errorListenerSubscribers) || {});
        errorListeners.forEach(function (listener) {
            var _a;
            (_a = listener) === null || _a === void 0 ? void 0 : _a(error);
        });
        if (typeof errors[errKey] === 'object') {
            notifyErrors(errors[errKey], formName + "." + errKey, setHasErrors);
        }
    });
};

var getRandomId = function () {
    return (Math.random() * 10000).toFixed(0);
};

var useFormFieldValue = function (fieldName, _a) {
    var _b = _a === void 0 ? {
        setterOnly: false,
    } : _a, optionalFormName = _b.formName, setterOnly = _b.setterOnly;
    var formNameFromContext = React.useContext(FormContext).formName;
    var formName = optionalFormName || formNameFromContext || getDefaultFormName();
    if (!Form[formName] && !optionalFormName) {
        throw new Error('NoFormFound')
            .message = 'No form was found in the context and you have not provided one. Did you forget to call `useForm()`?';
    }
    else if (!Form[formName]) {
        throw new Error('NoFormFound')
            .message = "No form was found for name " + formName + ". You need to pass this name to 'useForm()' config";
    }
    var _c = React.useState(objectPath.get(Form[formName].values, fieldName)), fieldValue = _c[0], setFieldValue = _c[1];
    var subId = React.useMemo(function () {
        var _a;
        if (setterOnly) {
            return;
        }
        var id = getRandomId();
        FormFieldSubscriptions[formName][fieldName] = __assign(__assign({}, (FormFieldSubscriptions[formName][fieldName] || {})), { changeListenerSubscribers: __assign(__assign({}, ((FormFieldSubscriptions[formName][fieldName] || {}).changeListenerSubscribers || {})), (_a = {}, _a[id] = function (value) {
                setFieldValue(value);
            }, _a)) });
        return id;
    }, []);
    // TODO unsubscribe trigger unmount
    return {
        set: buildOnChangeValue({ formName: formName, fieldName: fieldName }),
        value: fieldValue,
    };
};

var useFormInput = function (formInputProps) {
    var props = __assign({ saveUnmaskedValue: false }, formInputProps);
    var _a = React.useContext(FormContext), formNameFromContext = _a.formName, registerFieldFromContext = _a.registerField;
    var name = props.name, givenFormName = props.formName, givenInitialValue = props.initialValue, fieldRegistration = __rest(props, ["name", "formName", "initialValue"]);
    var formName = givenFormName || formNameFromContext;
    if (!formName) {
        throw new Error('NoFormFound')
            .message = 'No form was found in the context and you have not provided one. Did you forget to call `useForm()`?';
    }
    var registerField$$1 = registerFieldFromContext || registerField(formName);
    var fieldName = name;
    var initialValue = applyMask$1(objectPath.get(Form[formName].values, fieldName) || givenInitialValue || objectPath.get(Form[formName].initialValues, fieldName) || '', props);
    var _b = React.useState(initialValue), value = _b[0], setValue = _b[1];
    var _c = React.useState(undefined), error = _c[0], setError = _c[1];
    var _d = React.useMemo(function () {
        var defaults = getDefaults();
        return registerField$$1(__assign(__assign({ changeListener: setValue, errorListener: setError, fieldName: fieldName }, fieldRegistration), { validationOptions: __assign(__assign({}, defaults.validationOptions), props.validationOptions) }));
    }, [fieldName, formName]), onChange = _d.onChange, onError = _d.onError, onBlur = _d.onBlur;
    return {
        value: applyMask$1(value, props),
        error: error,
        setBlur: onBlur,
        setValue: onChange,
        setError: onError,
    };
};
var applyMask$1 = function (value, props) {
    var mask = props.mask, saveUnmaskedValue = props.saveUnmaskedValue;
    if (saveUnmaskedValue && typeof mask === 'function') {
        return mask(value);
    }
    return value;
};

var useFormFieldError = function (fieldName, _a) {
    var _b = _a === void 0 ? {
        setterOnly: false,
    } : _a, optionalFormName = _b.formName, setterOnly = _b.setterOnly;
    var formNameFromContext = React.useContext(FormContext).formName;
    var formName = optionalFormName || formNameFromContext || DEFAULT_FORM_NAME;
    if (!Form[formName] && !optionalFormName) {
        throw new Error('NoFormFound')
            .message = 'No form was found in the context and you have not provided one. Did you forget to call `useForm()`?';
    }
    else if (!Form[formName]) {
        throw new Error('NoFormFound')
            .message = "No form was found for name " + formName + ". You need to pass this name to 'useForm()'";
    }
    var _c = React.useState(Form[formName].values[fieldName]), fieldError = _c[0], setFieldError = _c[1];
    var subId = React.useMemo(function () {
        var _a;
        if (setterOnly) {
            return;
        }
        var id = Date.now().toString();
        FormFieldSubscriptions[formName][fieldName] = __assign(__assign({}, (FormFieldSubscriptions[formName][fieldName] || {})), { errorListenerSubscribers: __assign(__assign({}, ((FormFieldSubscriptions[formName][fieldName] || {}).errorListenerSubscribers || {})), (_a = {}, _a[id] = function (value) {
                setFieldError(value);
            }, _a)) });
        return id;
    }, []);
    // TODO unsubscribe
    return {
        set: buildOnChangeError({ formName: formName, fieldName: fieldName }),
        error: fieldError,
    };
};

exports.useForm = useForm;
exports.useFormFieldValue = useFormFieldValue;
exports.useFormInput = useFormInput;
exports.useFormFieldError = useFormFieldError;
exports.setDefaults = setDefaults;
exports.setEventBubblingEnabled = setEventBubblingEnabled;
//# sourceMappingURL=index.js.map
